//Core
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash.get';
import { Container } from '@material-ui/core';
//Local
import { Layout } from '../../../../components';
import {
  PreviewSec,
  ItemsSec,
  BannerSec,
} from '../../../../components/mediaCenterSections/blogCategory';
import * as MediaCenterActions from '../../../../redux/mediaCenter/actions';

const Engineering = ({ location }: { location: Object }) => {
  const tag = decodeURIComponent(location.hash.replace('#', ''));
  const engineeringPage = useSelector(
    (state) => state.mediaCenter.engineeringPage
  );
  const engineeringArticles = useSelector(
    (state) => state.mediaCenter.engineeringArticles
  );
  const dispatch = useDispatch();

  // Did mount
  useEffect(() => {
    dispatch(MediaCenterActions.getEngineeringPageAsync());
    dispatch(MediaCenterActions.getEngineeringArticlesAsync());
  }, [dispatch]);

  return (
    <Layout isMediaCenter>
      <Container maxWidth="md">
        <PreviewSec
          title={get(engineeringPage, 'pageTitle')}
          subtitle={get(engineeringPage, 'pageSubtitle')}
          card={{
            ...get(engineeringPage, 'primaryArticle.fields', {}),
            imgUrl: get(
              engineeringPage,
              'primaryArticle.fields.previewImage.fields.file.url'
            ),
            url: `/media_center/${get(
              engineeringPage,
              'primaryArticle.fields.blogSection.fields.urlKey'
            )}/article/${get(engineeringPage, 'primaryArticle.sys.id')}`,
            tags: get(engineeringPage, 'primaryArticle.fields.tags', []).map(
              (item) => item.fields.title
            ),
          }}
        />
        <ItemsSec
          title={get(engineeringPage, 'secondSectionTitle')}
          tags={get(engineeringPage, 'tags', [])}
          items={engineeringArticles}
          selectedTag={tag}
        />
      </Container>
      <BannerSec
        title={get(engineeringPage, 'thirdSectionTitle')}
        background={get(
          engineeringPage,
          'thirdSectionBackground.fields.file.url'
        )}
        buttonTitle={get(engineeringPage, 'thirdSectionButtonTitle')}
        buttonUrl={get(engineeringPage, 'thirdSectionButtonUrl')}
      />
    </Layout>
  );
};

export default Engineering;
